import React from "react";
import Navigation from "../components/Navigation";
import CaseStudiesHero from "../components/CaseStudiesHero";
import CaseStudyCards from "../components/CaseStudyCards";
import Footer from "../components/Footer";

const CaseStudiesPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <CaseStudiesHero />
      <CaseStudyCards />
      <Footer />
    </div>
  );
};

export default CaseStudiesPage;
